import { type FrontAuctionBidDTO, useIntl } from '@capsicum/common';
import { type LatestBidListRPProps } from '@capsicum/features/fanshop/shared';
import { BidderRowRP } from '@capsicum/features/fanshop/web';
import { useCallback } from 'react';
import styled from 'styled-components';

export const LatestBidListRP = ({ bidParticipants, isMyBid }: LatestBidListRPProps) => {
	const { $t } = useIntl();

	const BidList = useCallback(
		() => (
			<div>
				{bidParticipants?.map(
					(bidUser: FrontAuctionBidDTO, index: number) =>
						(bidUser.status === 'accepted' || bidUser.status === 'outbid') &&
						index < 3 && (
							<S.StyledBidderRowWrapper key={`${bidUser?.amount}-${index}`}>
								<BidderRowRP
									amount={bidUser?.amount ? Number(bidUser.amount) : 0}
									anonymizedName={bidUser?.userReference?.anonymizedName || ''}
									createdAt={bidUser?.createdAt}
									iso2Country={bidUser?.userReference?.countryCode}
									isOwnBid={isMyBid(bidUser?.userReference?.chilizUserId)}
								/>
							</S.StyledBidderRowWrapper>
						)
				)}
			</div>
		),
		[bidParticipants]
	);

	return (
		<div>
			<S.TitleWrapper>
				<S.Title>{$t('rewards.rpAuctions.latestBids')}</S.Title>
				<S.SubTitle>{$t('rewards.rpAuctions.rewardPoints')}</S.SubTitle>
			</S.TitleWrapper>

			<BidList />
		</div>
	);
};

namespace S {
	export const TitleWrapper = styled.div`
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const Title = styled.div`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const SubTitle = styled.div`
		${({ theme }) => theme.fonts.text.text4};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const StyledBidderRowWrapper = styled.div`
		margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	`;
}
